'use client';

import React, { useEffect } from 'react';

import Script from 'next/script';

import { useIsMounted, useLogger } from '@lib/hooks';

interface WatsonAiProps {
  integrationId?: string;
  serviceInstanceId?: string;
}

const WatsonAi: React.FC<WatsonAiProps> = ({ integrationId, serviceInstanceId }) => {
  const isMounted = useIsMounted();
  const log = useLogger('watson-ai');

  useEffect(() => {
    if (isMounted) {
      log.log(`init..., integrationId: ${integrationId}, serviceInstanceId: ${serviceInstanceId}`);
    }
  }, [integrationId, isMounted, log, serviceInstanceId]);

  if (!isMounted) {
    return null;
  }

  return (
    <Script id="watson-ai" strategy="lazyOnload">{`
      window.watsonAssistantChatOptions = {
        integrationID: "${integrationId}",
        region: "aws-eu-central-1",
        serviceInstanceID: "${serviceInstanceId}",
        orchestrateUIAgentExtensions: false,
        onLoad: async (instance) => { await instance.render(); }
      };
      setTimeout(function(){
        const t=document.createElement('script');
        t.src="https://web-chat.global.assistant.watson.appdomain.cloud/versions/" + (window.watsonAssistantChatOptions.clientVersion || 'latest') + "/WatsonAssistantChatEntry.js";
        document.head.appendChild(t);
      });
  `}</Script>
  );
};

export { WatsonAi };
